import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import RequiredLabel from "../RequiredLabel";

const initialErrorData = {
  pradesh: "",
  mandal: "",
  area: "",
  designation: "",
};

const Steps5 = ({
  count,
  setCount,
  detailsSet,
  details,
  initialData,
  completeCurrentStep,
}) => {
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState(initialErrorData);
  const [filteredMandals, setFilteredMandals] = useState([]);
  const [filteredAreas, setFilteredAreas] = useState([]);
  var userMemberId = localStorage.getItem("aimsUserMemberId");

  useEffect(() => {
    setFormData(details || {});
  }, [details]);

  // Filter mandals based on selected pradesh
  useEffect(() => {
    if (formData?.pradesh) {
      const selectedPradesh = initialData?.pradesh?.find(
        (p) => p.list_value === formData.pradesh
      );
      if (selectedPradesh) {
        const mandalsForPradesh = initialData?.mandal?.filter(
          (m) => m.parentid === selectedPradesh.masterlistid
        );
        setFilteredMandals(mandalsForPradesh || []);

        // Reset mandal and area if pradesh changes
        setFormData((prev) => ({
          ...prev,
          mandal: "",
          area: "",
        }));
        setFilteredAreas([]);
      }
    } else {
      setFilteredMandals([]);
    }
  }, [formData?.pradesh, initialData]);

  // Filter areas based on selected mandal
  useEffect(() => {
    if (formData?.mandal) {
      const selectedMandal = initialData?.mandal?.find(
        (m) => m.list_value === formData.mandal
      );
      if (selectedMandal) {
        const areasForMandal = initialData?.area?.filter(
          (a) => a.parentid === "76"
        );
        setFilteredAreas(areasForMandal || []);

        // Reset area if mandal changes
        setFormData((prev) => ({
          ...prev,
          area: "",
        }));
      }
    } else {
      setFilteredAreas([]);
    }
  }, [formData?.mandal, initialData]);

  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      setFormData({ ...formData, [name]: value });
    }
    // Clear errors for the field if it is filled
    if (value.trim() !== "") {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const transformData = (data) => {
    const mandal_info = {
      pradesh: data.pradesh || "",
      mandal: data.mandal || "",
      area: data.area || "",
      designation: data.designation || "",
    };

    return {
      mandal_info: mandal_info,
    };
  };

  const validateForm = () => {
    const newErrors = { ...initialErrorData };
    let isValid = true;

    if (!formData.pradesh || formData.pradesh.trim() === "") {
      newErrors.pradesh = "Please select Pradesh Name";
      isValid = false;
    }

    if (!formData.mandal || formData.mandal.trim() === "") {
      newErrors.mandal = "Please select Mandal Name";
      isValid = false;
    }

    if (!formData.area || formData.area.trim() === "") {
      newErrors.area = "Please select Area Name";
      isValid = false;
    }

    if (!formData.designation || formData.designation.trim() === "") {
      newErrors.designation = "Please select Designation Name";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formattedData = transformData(formData);
      detailsSet(formData);
      sendMandalDetails(formattedData);
    }
  };

  const sendMandalDetails = (el) => {
    axios
      .post(
        `https://anoopam.com/aims/api/?action=mandaldetails&memberid=${userMemberId}`,
        { ...el }
      )
      .then((res) => {
        if (res?.data?.status === "success") {
          Swal.fire({
            text: `${res?.data?.msg}`,
            icon: "success",
          });
          setCount(count + 1);
          completeCurrentStep(count);
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error",
        });
      });
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="mt-4 main p-4 border rounded-4 bg-white">
        <div className="row">
          <div className="col-md-6">
            <RequiredLabel htmlFor="Pradesh Name">Pradesh Name</RequiredLabel>
            <select
              name="pradesh"
              value={formData?.pradesh || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.pradesh?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.pradesh && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.pradesh}
              </span>
            )}
          </div>

          <div className="col-md-6">
            <RequiredLabel htmlFor="Professional Education">
              Mandal Name
            </RequiredLabel>
            <select
              name="mandal"
              value={formData?.mandal || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
              disabled={!formData?.pradesh}
            >
              <option className="inputText" value="">
                Select...
              </option>
              {filteredMandals.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              ))}
            </select>
            {errors?.mandal && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.mandal}
              </span>
            )}
          </div>

          <div className="col-md-6 mt-4">
            <RequiredLabel htmlFor="area">Area Name</RequiredLabel>
            <select
              name="area"
              value={formData?.area || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
              disabled={!formData?.mandal}
            >
              <option className="inputText" value="">
                Select...
              </option>
              {filteredAreas.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              ))}
            </select>
            {errors?.area && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.area}
              </span>
            )}
          </div>

          <div className="col-md-6 mt-4">
            <RequiredLabel htmlFor="name">Designation Name</RequiredLabel>
            <select
              name="designation"
              value={formData?.designation || ""}
              onChange={handleInputChange}
              className="form-select mt-2"
              aria-label="Default select example"
            >
              <option className="inputText" value="">
                Select...
              </option>
              {initialData?.designation?.map((title, index) => (
                <option key={index} value={title?.list_value}>
                  {title?.list_label}
                </option>
              )) || <option>Loading...</option>}
            </select>
            {errors?.designation && (
              <span className="text-danger fw-medium d-inline-flex">
                {errors?.designation}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            type="button"
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 6 && (
          <button type="submit" className="rounded-5 btnBlue">
            Next
          </button>
        )}
      </div>
    </form>
  );
};

export default Steps5;
